<template>
    <div>
        <l-map style="height: 85vh" :zoom="zoom" :max-bounds="maxBounds">
            <l-tile-layer :url="url">
                <l-marker :lat-lng="withPopup">
                    <l-popup>
                        <div @click="innerClick">
                            I am a popup
                            <p v-show="showParagraph">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                                sed pretium nisl, ut sagittis sapien. Sed vel sollicitudin nisi.
                                Donec finibus semper metus id malesuada.
                            </p>
                        </div>
                    </l-popup>
                </l-marker>
                <l-marker :lat-lng="withTooltip">
                    <l-tooltip :options="{ permanent: true, interactive: true }">
                        <div @click="innerClick">
                            I am a tooltip
                            <p v-show="showParagraph">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                                sed pretium nisl, ut sagittis sapien. Sed vel sollicitudin nisi.
                                Donec finibus semper metus id malesuada.
                            </p>
                        </div>
                    </l-tooltip>
                </l-marker>
            </l-tile-layer>
        </l-map>
    </div>
</template>

<script>
    import { latLngBounds, latLng } from "leaflet";
    import {LMap, LTileLayer} from 'vue2-leaflet';

    export default {
        components: { LMap, LTileLayer, },
        data () {
            return {
                url: '/{z}/{x}/{y}.png',
                zoom: 3,

                center: [0, 0],
                withPopup: latLng(-966.00000000, 2038.00000000,),
                withTooltip: latLng(-968.00000000, 2048.00000000,),
                currentZoom: 11.5,
                currentCenter: latLng(47.41322, -1.219482),
                showParagraph: false,
                mapOptions: {
                    zoomSnap: 0.5
                },
            };
        }
    }
</script>
